import React from 'react';
import { makeStyles } from '@material-ui/styles';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';


import logoImg from 'assets/logo-bg-white.svg';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '20px 0',
    backgroundColor: '#fff',
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(5),
    [theme.breakpoints.down('md')]: {
      marginBottom: theme.spacing(1),
    },
  },
  logo: {
    width: 130,
    marginRight: theme.spacing(4),
  },
  navs: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    '& a': {
      letterSpacing: '2px',
      padding: '.75em 1em',
      color: '#171819',
      '&:last-child': {
        paddingRight: 0
      }
    },
    [theme.breakpoints.down('md')]: {
      display: 'none'
    }
  }
}));

const Header = ({ hideNav }) => {
  const classes = useStyles();
  return (
    <header className={classes.root}>
      <a href="https://www.weadmit.com/">
        <img src={logoImg} className={classes.logo} />
      </a>
      {!hideNav && (
        <Box className={classes.navs}>
          <a href="https://www.weadmit.com/programs">Our Programs</a>
          <a href="https://www.weadmit.com/counselors">Counselors</a>
          <a href="https://www.weadmit.com/we-advise">WeAdvise</a>
          <a href="https://www.weadmit.com/welearn">WeLearn</a>
          <a href="https://www.weadmit.com/about">About Us</a>
          <Box marginLeft="auto">
            <a href="http://app.weadmit.com/">
              <Button color="primary" variant="outlined">
                Login
              </Button>
            </a>
            <a href="https://www.weadmit.com/free-consultation">
              <Button color="primary" variant="contained">
                Free Counseling
              </Button>
            </a>
          </Box>
        </Box>
      )}
    </header>
  );
};

export default Header;
